export default __webpack_public_path__ + "static/media/ARTIST-13 (1-1).07ce0d02.jpg";